export default "__VITE_PUBLIC_ASSET__8280c21d__"